export default {
    "open_equity": "بدءاً من حقوق الملكية",
    "bonus": "المكافأة",
    "closed_positions": "المراكز المغلقة",
    "finance": "التمويل",
    "watchlist": "قائمة المراقبة",
    "calendar": "التقويم",
    "symbol_information": "معلومات الرمز",
    "contact_size": "حجم الاتصال",
    "min_tick_size": "الحد الأدنى لحجم التجزئة",
    "min_lot": "الحصة الصغرى",
    "max_lot": "ماكس لوت",
    "pip_size": "حجم البيب",
    "stop_limit_levels": "مستويات الإيقاف والحد",
    "base_currency": "اقتباس العملة",
    "swap_type": "نوع المبادلة",
    "digits": "الأرقام",
    "trade_id": "المعرف التجاري",
    "sell_buy": "البيع/الشراء",
    "instrument": "الأداة",
    "open_current_price": "السعر المفتوح/السعر الحالي",
    "s_slash_l": "س/ل",
    "profit_slash_loss": "الربح/الخسارة",
    'net_pl':'صافي P/L',
    "comment": "تعليق",
    "action": "الإجراء",
    "proximity": "القرب",
    "buy_stop": "إيقاف الشراء",
    "buy_limit": "حد الشراء",
    "stop_loss": "وقف الخسارة",
    "rate": "المعدل",
    "take_profit": "جني الأرباح",
    "price": "السعر",
    "maximum_20_characters": "20 حرفاً كحد أقصى",
    "btn_place_buy_order": "تقديم طلب شراء",
    "btn_place_sell_order": "تقديم طلب بيع",
    "change": "التغيير",
    "descrption": "الوصف",
    "asset_class": "فئة الأصول",
    "subclass": "الفئة الفرعية",
    "major": "الرائد",
    "size_of_1_pip": "حجم 1 نقطة",
    "Min_position_size": "الحد الأدنى حجم الموضع",
    "Max_position_size": "الحد الأقصى حجم الموضع",
    "leverage": "الرافعة المالية",
    "daily_swap_points": "نقاط المبادلة اليومية",
    "long": "طويل",
    "short": "قصير",
    "market_hours_local_time": "ساعات عمل السوق (بالتوقيت المحلي)",
    "main_trading": "الرئيسية/التداول",
    "copy_trade": "نسخ التجارة",
    "view_modes": "عرض الأوضاع",
    "reports": "التقارير",
    "pivot_table": "جدول محوري",
    "pp": "ص",
    "s1": "S1",
    "s2": "S2",
    "s3": "S3",
    "r1": "R1",
    "r2": "R2",
    "r3": "R3",
    "list_property": "قائمة الممتلكات",
    "overview": "لمحة عامة",
    "day_low": "يوم منخفض",
    "prev_close": "السابق إغلاق",
    "day_high": "يوم عالٍ",
    "52_week_low": "أدنى مستوى في 52 أسبوع",
    "1_day_range": "1 نطاق اليوم الواحد",
    "52_day_range": "نطاق 52 يوماً",
    "daily": "يومياً",
    "weekly": "أسبوعياً",
    "monthly": "شهرياً",
    "moving_averages": "المتوسطات المتحركة",
    "technical_indicators": "المؤشرات الفنية",
    "charts": "الرسوم البيانية",
    "trade_log": "السجل التجاري",
    "create_new_watchlist": "إنشاء قائمة مراقبة جديدة",
    "net_profit": "صافي الربح",
    "maximum_equity_drawdown": "الحد الأقصى للسحب من الأسهم",
    "profit_percentage": "النسبة المئوية للأرباح",
    "opening_balance": "بدء الرصيد",
    "current_balance": "الرصيد الحالي",
    "deposit": "الإيداع",
    "withdrawal": "الانسحاب",
    "economic_calendar": "التقويم الاقتصادي",
    "dashboard": "لوحة التحكم",
    "markets": "الأسواق",
    "portfolio": "المحفظة",
    "buzz": "الطنانة",
    "view_profile": "عرض الملف الشخصي",
    "equity": "حقوق الملكية",
    "realized_profit": "الأرباح المحققة",
    "unrealized_profit": "الأرباح غير المحققة",
    "balance": "الرصيد",
    "used_margin": "الهامش المستعمل",
    "free_margin": "الهامش المجاني",
    "profile": "الملف الشخصي",
    "settings": "الإعدادات",
    "theme": "الموضوع",
    "logout": "تسجيل الخروج",
    "trading_account": "حساب التداول",
    "quick_links": "روابط سريعة",
    "back": "رجوع",
    "previous": "السابق",
    "forecast": "التنبؤات",
    "actual": "الفعلية",
    "data": "التاريخ",
    "margin_level": "مستوى الهامش",
    "news": "الأخبار",
    "unrealised_pl": "صافي الربح/الخسارة غير المحقق",
    "unrealised_gross_pl": "إجمالي ربح/لتر غير محقق",
    "quantity": "الكمية",
    "trailing_sl": "زائدة عن الحد المسموح به",
    "sell": "البيع",
    "buy": "اشترِ",
    "open_positions": "المناصب الشاغرة",
    "close_all_profitable": "إغلاق جميع المربح",
    "close_all_losing": "إغلاق جميع الخاسرين",
    "close_all_buy": "إغلاق جميع عمليات الشراء",
    "close_all_sell": "إغلاق جميع عمليات البيع",
    "no": "لا يوجد",
    "yes": "نعم",
    "are_you_sure": "هل أنت متأكد أنك تريد",
    "current_market_rates": "بأسعار السوق الحالية؟",
    "close_all": "إغلاق الكل",
    "watchlists": "قوائم المراقبة",
    "default": "افتراضي",
    "add_new_watchlist": "إضافة قائمة مراقبة جديدة",
    "delete_watchlist?": "هل تريد بالتأكيد حذف قائمة المراقبة هذه؟",
    "cancel": "إلغاء",
    "delete": "حذف",
    "delete_alert": "هل أنت متأكد من رغبتك في حذف هذا التنبيه؟",
    "condition": "الحالة",
    "triggered": "مُشغّل",
    "active": "نشط",
    "alert": "تنبيه",
    "alerts": "تنبيهات",
    "going_below": "الذهاب إلى الأسفل",
    "going_above": "الذهاب إلى ما هو أعلى",
    "bid_price": "سعر العطاء",
    "ask_price": "اسأل عن السعر",
    "symbol": "الرمز",
    "edit_alert": "تحرير تنبيه",
    "create_alert_on": "إنشاء تنبيه على",
    "info": "المعلومات",
    "daily_range": "النطاق اليومي",
    "spread": "الانتشار",
    "contract_size": "حجم العقد",
    "min_trade_size": "الحد الأدنى لحجم التداول",
    "max_trade_size": "الحد الأقصى لحجم التداول",
    "swap_long": "مقايضة طويلة",
    "swap_short": "مقايضة قصيرة",
    "create_alert": "إنشاء تنبيه",
    "remove_watchlist": "إزالة من قائمة المراقبة",
    "trading_view_chart": "الرسم البياني لعرض التداول",
    "chart": "الرسم البياني",
    "add": "إضافة",
    "add_instruments_watchlist": "إضافة أدوات إلى قائمة المراقبة الخاصة بك",
    "h": "H",
    "l": "L",
    "cryptos": "العملات المشفرة",
    "indices": "المؤشرات",
    "forex": "الفوركس",
    "fx": "العملات الأجنبية",
    "stocks": "الأسهم",
    "comm": "الاتصال",
    "commodities": "السلع الأساسية",
    "low": "منخفضة",
    "high": "عالية",
    "change_percentage": "النسبة المئوية للتغيير",
    "bid": "العطاءات",
    "ask": "اسأل",
    "order": "الطلب",
    "commission": "المفوضية",
    "swap": "مقايضة",
    "open_date": "التاريخ المفتوح",
    "lots": "الكثير",
    "b_slash_s": "ب/س",
    "open_price": "السعر المفتوح",
    "order_price": "سعر الطلب",
    "current_price": "السعر الحالي",
    "comments": "التعليقات",
    "modify": "تعديل",
    "close": "إغلاق",
    "ok": "حسناً",
    "trailing_stop": " الإيقاف المتحرك",
    "trailing_stop_loss": "وقف الخسارة المتحرك",
    "quntity": "كونتيتي",
    "price_level": "مستوى السعر",
    "type": "النوع",
    "trades": "الصفقات",
    "order_id": "معرّف الطلب",
    "modify_order": "تعديل الترتيب",
    "revert": "الرجوع",
    "id": "بطاقة الهوية",
    "sl": "س.ل",
    "tp": "TP",
    "close_order": "إغلاق الطلب",
    "trail_s_slash_l": "المسار S/لتر",
    "pnl_s": "Pnl",
    "direction": "الاتجاه",
    "modify_position": "تعديل الوضع",
    "close_price": "إغلاق السعر",
    "close_date": "تاريخ الإغلاق",
    "total_p_slash_l": "إجمالي الربح/الخسارة",
    "place_new_order": "ضع طلبية جديدة",
    "close_time": "وقت الإغلاق",
    "open_time": "الوقت المفتوح",
    "p_slash_l": "ف/لتر",
    "reason": "السبب",
    "qty": "الكمية",
    "pending_orders": "الطلبات المعلقة",
    "order_type": "نوع الطلب",
    "close_all_orders": "هل أنت متأكد من أنك تريد إغلاق جميع الطلبات المفتوحة؟",
    "place_order": "تقديم الطلب",
    "advanced_options": "خيارات متقدمة",
    "available_margin": "الهامش المتاح",
    "trade": "التجارة",
    "positions": "المناصب",
    "orders": "الطلبات",
    "history": "التاريخ",
    "summary": "الملخص",
    "summary_from": "ملخص من:",
    "performance": "الأداء",
    "profitability": "الربحية",
    "password_validation": "يجب ألا يقل طول كلمة المرور عن 8 أحرف، وحرف خاص واحد، وحرف واحد، ورقم واحد.",
    "note": "ملاحظة",
    "change_password": "تغيير كلمة المرور",
    "submit": "إرسال",
    "select_server_type": "حدد نوع الخادم",
    "create_demo_account": "إنشاء حساب تجريبي",
    "create_new_account": "إنشاء حساب جديد",
    "account_id": "معرّف الحساب",
    "name": "الاسم",
    "currency": "العملة",
    "security": "الأمن",
    "amount": "المبلغ",
    "select_leverage": "اختر الرافعة المالية",
    "select_currency": "اختر العملة",
    "save_settings": "حفظ الإعدادات",
    "large": "كبير",
    "small": "صغيرة",
    "font_size": "حجم الخط",
    "units": "الوحدات",
    "select_show": "اختر العرض",
    "order_position_size": "الترتيب/الموضع الحجم في",
    "custom": "مخصص",
    "month": "الشهر",
    "days": "الأيام",
    "day": "اليوم",
    "select": "اختر",
    "history_range": "نطاق التاريخ",
    "default_lot_size": "الحجم الافتراضي للقطعة",
    "local_time": "التوقيت المحلي",
    "server": "الخادم",
    "timezone": "المنطقة الزمنية",
    "enable": "التمكين",
    "modify_trade": "تعديل التجارة",
    "open": "مفتوح",
    "enter_quantity": "أدخل الكمية",
    "tooltip": "تلميح الأدوات",
    "field": "الحقل",
    "value": "القيمة",
    "date_time": "التاريخ/الوقت",
    "market": "السوق",
    "all": "الكل",
    "verify": "تحقق",
    "volume": "الحجم",
    "lot": "الكثير",
    "quantity_required": " الكمية مطلوبة.",
    "stop_loss_required": " وقف الخسارة مطلوب.",
    "distance_points": "المسافة من السعر الحالي",
    "points": "النقاط",
    "back_to_login": "العودة إلى تسجيل الدخول",
    "forgot_password": "هل نسيت كلمة المرور؟",
    "enter_username": "أدخل اسم المستخدم",
    "login": "تسجيل الدخول",
    "remember_me": "تذكّرني",
    "login_another_account": "تسجيل الدخول بحساب آخر",
    "2fa_verification": "التحقق من المصادقة 2FA",
    "my_profile": "ملفي الشخصي",
    "user_name": "اسم المستخدم",
    "email": "البريد الإلكتروني",
    "already_have_account": " هل لديك حساب بالفعل؟",
    "register": "التسجيل",
    "last_name": "الاسم العائلي",
    "first_name": "الاسم الأول",
    "password": "كلمة المرور",
    "disable_two_factor_auth": "تعطيل المصادقة الثنائية العوامل",
    "enter_6_digit_code": "أدخل رمز التحقق المكون من 6 أرقام الذي تم إنشاؤه.",
    "enable_two_factor_authentication": "تمكين المصادقة الثنائية",
    "please_click_2fa_enable": "الرجاء النقر على خيار 2FA الذي تريد تمكينه.",
    "download_authenticator_app": "تنزيل تطبيق المصادقة",
    "download_install_google_authenticator": "قم بتنزيل Authy أو Google Authenticator وتثبيته على هاتفك أو جهازك اللوحي.",
    "scan_code": "امسح رمز الاستجابة السريعة ضوئياً",
    "open_authentication_app_camera": "افتح تطبيق المصادقة وامسح الصورة الموجودة على اليسار باستخدام كاميرا هاتفك",
    "login_code": "تسجيل الدخول باستخدام الرمز الخاص بك",
    "two_factor_authentication": "المصادقة الثنائية",
    "2fa_already_enabled": "تم تمكين المصادقة الثنائية (2FA) بالفعل يرجى النقر فوق خيار المصادقة الثنائية (2FA) الذي تريد تعطيله.",
    "usd": "دولار أمريكي",
    "eur": "اليورو",
    "gbp": "الجنيه الإسترليني",
    "aud": "الدولار الأمريكي",
    "enter_6_digit_code_placeholder": "أدخل الرمز المكون من 6 أرقام",
    "enter_google_verification_code": "أدخل رمز التحقق من Google",
    "trading_id_placeholder": "أدخل معرّف التداول الخاص بك",
    "password_placeholder": "أدخل كلمة المرور الخاصة بك",
    "email_placeholder": "أدخل بريدك الإلكتروني",
    "enter_old_password": "أدخل كلمة المرور الحالية",
    "enter_new_password": "أدخل كلمة مرور جديدة",
    "enter_new_password_again": "أدخل كلمة المرور الجديدة مرة أخرى",
    "alpha_numeric_dashes_underscores_spaces": "يمكن أن يحتوي الحقل على أحرف أبجدية رقمية فقط بالإضافة إلى الشرطات والشرطات السفلية والمسافات",
    "is_required": "مطلوب",
    "field_must_be": " يجب أن يكون الحقل",
    "or_more": "أو أكثر.",
    "or_less": "أو أقل.",
    "must_be_greater_then": "يجب أن يكون أكبر إذن.",
    "must_be_less_then": "يجب أن يكون أقل من",
    "not_valid": "غير صالح",
    "buy_stop_loss_error_message": "يجب أن يكون وقف الخسارة أقل من سعر السوق",
    "trailing_stop_required": "الإيقاف المتحرك مطلوب.",
    "trailing_stop_greater_zero": "يجب أن يكون الإيقاف المتحرك أكبر من",
    "target_price_required": "السعر المستهدف مطلوب.",
    "target_price_greater_trigger": "يجب أن يكون السعر المستهدف أكبر من السعر الحالي و",
    "trigger_price": "سعر الزناد",
    "price_required": "السعر مطلوب.",
    "price_must_be_greater_than": "يجب أن يكون السعر أكبر من",
    "target_price_greater_price_level": "يجب أن يكون السعر المستهدف أكبر من مستوى السعر",
    "price_must_be_less_than": "يجب أن يكون السعر أقل من",
    "and_greater_than_zero": "وأكبر من",
    "stop_loss_less_price_level_greater_zero": "يجب أن يكون وقف الخسارة أقل من مستوى السعر وأكبر من",
    "target_price_less_trigger": "يجب أن يكون السعر المستهدف أقل من السعر الحالي وأكبر من",
    "sell_stop": "إيقاف البيع",
    "sell_limit": "حد البيع",
    "sell_stop_loss_error_message": "يجب أن يكون وقف الخسارة أكبر من سعر السوق",
    "placed_order_pending_wait": "طلبك الذي تم تقديمه معلق، يُرجى الانتظار",
    "place_other_order": "تقديم طلبات أخرى",
    "no_account_id_found": "لم يتم العثور على معرف حساب",
    "target_price_must_less_than_trigger_price_greater_zero": "يجب أن يكون السعر المستهدف أقل من السعر الزناد وأكبر من",
    "sell_stop_loss_greater_trigger_price": "يجب أن يكون وقف الخسارة أكبر من سعر التنفيذ",
    "create_new_alert": "إنشاء تنبيه جديد",
    "losing": "الخسارة",
    "winning": "الفوز",
    "avg_trade_size": "متوسط حجم التداول المتوسط",
    "asset": "الأصول",
    "trades_lost": "الصفقات المفقودة",
    "trades_won": "الصفقات الرابحة",
    "total_trades": "إجمالي التداولات",
    "total_trading_volume": "إجمالي حجم التداول",
    "resend": "إعادة الإرسال",
    "reset_password_msg": "يرجى التحقق من عنوان البريد الإلكتروني للحصول على تعليمات لإعادة تعيين كلمة المرور الخاصة بك.",
    "server_type": "نوع الخادم",
    "check_email": "تحقق من بريدك الإلكتروني",
    "technicals": "التقنيات",
    "disable": "تعطيل",
    "amount_greater_100000": "يجب ألا يزيد المبلغ عن 100000",
    "x": "X",
    "password_required": "كلمة المرور مطلوبة.",
    "proceed": "تابع",
    "turnkey_forex": "تيرن كي فوركس",
    "coinexx": "كوينكس",
    "finpro_trading": "فينبرو للتجارة",
    "hankotrade": "هانكوتريد",
    "brokers": "الوسطاء",
    "select_broker": "اختر وسيطاً",
    "edit_price_alert": "تحرير تنبيه الأسعار",
    "create_price_alert": "إنشاء تنبيه الأسعار",
    "maximum_100_characters": "100 حرف كحد أقصى",
    "add_comment": "إضافة تعليق",
    "price_must_be": "يجب أن يكون السعر",
    "then": "ثم",
    "crossing_above": "عبور أعلاه",
    "crossing_below": "العبور أدناه",
    "total_records": "إجمالي السجلات",
    "no_data_found": "لا توجد بيانات",
    "show_more": "اعرض المزيد",
    "show_less": "عرض أقل",
    "at": "في",
    "trail": "الدرب",
    "order_pending": "الطلب معلق",
    "target_price_less_market_greater_zero": "يجب أن يكون السعر المستهدف أقل من نطاق السوق وأكبر من",
    "stop_loss_less_market_price_greater_zero": "يجب أن يكون وقف الخسارة أقل من سعر السوق الحالي وأكبر من",
    "stop_loss_greater_market_range": "يجب أن يكون وقف الخسارة أكبر من نطاق السوق",
    "target_price_greater_market_price": "يجب أن يكون السعر المستهدف أكبر من سعر السوق الحالي",
    "watchlist_create": "إنشاء قائمة مراقبة",
    "update": "تحديث",
    "delete_symbol": "حذف الرمز",
    "are_sure_delete_symbol": "هل تريد بالتأكيد حذف هذا الرمز؟",
    "symbol_name": "اسم الرمز",
    "edit_symbol": "تحرير الرمز",
    "enter_watchlist_name": "أدخل اسم قائمة المراقبة",
    "search_title": "رموز البحث",
    "b": "B",
    "s": "S",
    "a": "A",
    "username": "اسم المستخدم",
    "email_address": "عنوان البريد الإلكتروني",
    "old_password_validation": "كلمة المرور القديمة مطلوبة.",
    "old_password_greater_characters": "لا يجوز أن تكون كلمة المرور القديمة أكبر من 20 حرفاً",
    "new_password_validation": "كلمة المرور الجديدة مطلوبة",
    "confirm_password_is_required": "مطلوب تأكيد كلمة المرور.",
    "entered_password_not_match": "كلمات المرور المدخلة غير متطابقة. يرجى المحاولة مرة أخرى",
    "display_high_slash_low_grid_view": "عرض مرتفع/منخفض في عرض الشبكة",
    "display_spread_grid_view": "عرض الانتشار في عرض الشبكة",
    "select_to_date": "اختر حتى الآن",
    "select_from_date": "اختر من التاريخ",
    "select_show_order_slash_position_size_in": "إظهار الترتيب/حجم الموضع في",
    "select_history_range": "تحديد نطاق التاريخ",
    "lot_size_greater_than": "يجب ألا يزيد حجم قطعة الأرض عن",
    "select_time_zone": "اختر المنطقة الزمنية",
    "select_font_size": "حدد حجم الخط",
    "select_mode_view_suits": "اختر طريقة العرض التي تناسبك.",
    "selected": "مختارة",
    "basic_chart_view": "عرض الرسم البياني الأساسي",
    "grid_view": "عرض الشبكة",
    "multi_chart_view": "عرض الرسم البياني المتعدد",
    "settings_effect_trading_page": "تسري هذه الإعدادات على صفحة التداول فقط.",
    "market_watch": "مراقبة السوق",
    "favorite": "المفضلة",
    "one_click_trading": "التداول بنقرة واحدة",
    "new_watchlist": "قائمة المراقبة الجديدة",
    "maximum_5_watchlists": "يمكنك إنشاء 5 قوائم مراقبة كحد أقصى.",
    "new_watchlist_successfully": "تمت إضافة قائمة المراقبة الجديدة بنجاح",
    "delete_watchlist": "حذف قائمة المراقبة",
    "delete_watchlist_successfully": "تم حذف قائمة المراقبة بنجاح",
    "edit_watchlist": "تحرير قائمة المراقبة",
    "watchlist_updated_successfully": "تم تحديث قائمة المراقبة بنجاح",
    "go_to_order": "انتقل إلى الطلب",
    "search_filter_fx": "العملات الأجنبية",
    "mon": "الإثنين",
    "tue": "الثلاثاء",
    "wed": "الأربعاء",
    "thu": "الخميس",
    "fri": "الجمعة",
    "sat": "سبت",
    "sun": "الشمس",
    "olivia_deo": "أوليفيا ديو",
    "risk": "المخاطر",
    "profit": "الأرباح",
    "copiers": "آلات النسخ",
    "win_rate": "معدل الفوز",
    "greetings_des": "تحياتي، نظامي الذي أقدمه هنا يتطلب إعدادات الحساب التالية: 600 دولار أمريكي ----> 0.01 لوت نحن نجري صفقات قليلة جداً هنا سنوياً، ما بين 60-200 صفقة، الصفقات الضرورية جداً بحيث - نحافظ على تراجعنا عند أدنى مستوى ممكن من خلال القيام بالصفقات المطلوبة جداً. -نحن نبحر بمتوسط أعلى من 30 نقطة في كل صفقة. *نسمح لجميع التداولات من هذا النظام بتحقيق نتائج مماثلة. لذا اشعر بالترحيب وأنت تنمي حسابك بثبات معنا وتحلى بالصبر الشديد.",
    "live_profit": "الربح المباشر",
    "overall": "بشكل عام",
    "advanced_seats": "مقاعد متقدمة",
    "trading": "التداول",
    "drawDown": "سحب لأسفل",
    "pips": "النقاط",
    "include_unrealized_pnl": "تشمل الأرباح غير المحققة",
    "closed_trades_only": "الصفقات المغلقة فقط",
    "trades_volume": "حجم التداولات",
    "by_pair": "بواسطة زوج",
    "best_worst": "الأفضل والأسوأ",
    "ranking": "الترتيب",
    "paris": "باريس",
    "trading_news": "أخبار التداول",
    "prev": "السابق",
    "next": "التالي",
    "follow": "اتبع",
    "investment": "الاستثمار",
    "open_date_time": "تاريخ ووقت الفتح",
    "close_date_time": "تاريخ ووقت الإغلاق",
    "roll": "تدحرج",
    "total": "الإجمالي",
    "aud_slash_cad": "الدولار الأسترالي/الدولار الأمريكي",
    "position_list": "قائمة المناصب",
    "trade_history": "تاريخ التجارة",
    "completed": "مكتمل",
    "rejected": "مرفوض",
    "pending_closed": "في انتظار الإغلاق",
    "close_time_date": "تاريخ وقت الإغلاق",
    "status": "الحالة",
    "hedge_position": "موقف التحوط",
    "partial_close": "إغلاق جزئي",
    "stop_loss_less_then": "يجب أن يكون وقف الخسارة أقل من",
    "greater_then_zero": "وأكبر بعد ذلك",
    "trailing_stop_greater_one": "يجب أن يكون الإيقاف المتحرك أكبر من",
    "greater_then": "يجب أن يكون السعر المستهدف أكبر من",
    "stop_loss_greater_then": "يجب أن يكون وقف الخسارة أكبر إذن",
    "target_price_less_then": "يجب أن يكون السعر المستهدف أقل من",
    "volume_required": "الحجم مطلوب.",
    "volume_less_then": "يجب أن يكون الحجم أقل من",
    "PNL": "PNL",
    "lot_size_partial": "حجم قطعة الأرض أقل من الإغلاق الجزئي",
    "price_greater_then": "يجب أن يكون السعر أكبر إذن",
    "stop_loss_less_greater_then_zero": "يجب أن يكون وقف الخسارة أقل من مستوى السعر وأكبر من 0",
    "trailing_stop_greate_then_zero": "يجب أن يكون الإيقاف المتحرك أكبر إذن",
    "stop_loss_trigger_price": "يجب أن يكون وقف الخسارة أكبر من سعر الزناد",
    "date_range": "نطاق التاريخ",
    "from": "من",
    "to": "إلى",
    "target_price_greater_then_zero": "يجب أن يكون السعر المستهدف أقل من سعر الزناد وأكبر منه",
    "target_price_market_range_greater_zero": "يجب أن يكون السعر المستهدف أقل من نطاق السوق وأكبر منه",
    "order_list": "قائمة الطلبات",
    "close_all_trades": "إغلاق جميع الصفقات",
    "instrument_name": "اسم الأداة",
    "trade_logs": "السجلات التجارية",
    "transaction_ID": "معرّف المعاملة",
    "add_more_leader": "إضافة المزيد من القادة",
    "total_Profit": "إجمالي الربح",
    "invested": "مستثمر",
    "market101_guard_enabled": "تم تمكين حارس السوق101",
    "excessive_losses": "تم تعطيل القائد بسبب الخسائر المفرطة.",
    "filter": "التصفية",
    "remember_filters": "تذكر الفلاتر",
    "toggle": "تبديل",
    "matrix": "المصفوفة",
    "select_all": "اختر الكل",
    "term": "المدة",
    "apply": "قدم طلبك",
    "clear_all": "مسح الكل",
    "follow_more": "تابع المزيد",
    "go_to_dashboard": "الانتقال إلى لوحة التحكم",
    "are_you_sure_stop_coping": "هل أنت متأكد من أنك تريد التوقف عن نسخ هذا المعلم؟",
    "invested_amount": "المبلغ المستثمر",
    "max": "ماكس",
    "insufficient_funds": "عدم كفاية الأموال في الحساب.",
    "enter_valid_amount": "يُرجى إدخال مبلغ صحيح.",
    "maximum_amount_allowed": "الحد الأقصى للمبلغ المسموح به يصل إلى",
    "available_capital": "رأس المال المتاح",
    "copy_open_trades": "نسخ التداولات المفتوحة",
    "stop_following": "توقف عن المتابعة",
    "leaders": "القادة",
    "back_to_manual_trading": "العودة إلى التداول اليدوي",
    "advanced_stats": "إحصائيات متقدمة",
    "view_all": "عرض الكل",
    "roi": "العائد على الاستثمار",
    "load_more": "تحميل المزيد",
    "powered_by": "مدعوم من",
    "act_trader": "متداول بالنيابة"
  }


// WEBPACK FOOTER //
// ./src/plugins/lang/languages/ar.js